import { render, staticRenderFns } from "./Heart.vue?vue&type=template&id=9f5991c6&scoped=true&name=heart&"
import script from "./Heart.vue?vue&type=script&lang=js&"
export * from "./Heart.vue?vue&type=script&lang=js&"
import style0 from "./Heart.vue?vue&type=style&index=0&id=9f5991c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5991c6",
  null
  
)

/* custom blocks */
import block0 from "./Heart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports